import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { version } from "../package.json";
export default function request(_x, _x2, _x3, _x4) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(engineKey, method, path, params) {
    var headers, response, json, message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = new Headers({
              "Content-Type": "application/json",
              "x-swiftype-integration": "search-ui",
              "x-swiftype-integration-version": version
            });
            _context.next = 3;
            return fetch("https://search-api.swiftype.com/api/v1/public/".concat(path), {
              method: method,
              headers: headers,
              body: JSON.stringify(_objectSpread({
                engine_key: engineKey
              }, params)),
              credentials: "include"
            });

          case 3:
            response = _context.sent;
            _context.prev = 4;
            _context.next = 7;
            return response.json();

          case 7:
            json = _context.sent;
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);

          case 12:
            if (!(response.status >= 200 && response.status < 300)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", json);

          case 16:
            message = json && json.error ? json.error : response.status;
            throw new Error(message);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
  return _request.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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